import React, { useEffect, useState } from 'react';
import NumberInputWithUnit from '../../../../../../atomic/inputs/numberInputWithUnit/NumberInputWithUnit';
import InfoIconComponent from '../../InfoIcon';
import style from './ExitTacticModules.module.css';
import PropTypes from 'prop-types';
import { GreenToRedPositionsDocs } from '../../../../documentation/GreenToRedDocumentation';

function GreenToRedPositionsModule({ state }) {
  const [
    greenToRedPositions,
    dispatchGreenToRedPositions,
    ,
    setGreenToRedPositionsEnabled,
  ] = state;

  const [inRightDirectionPctDisplay, setInRightDirectionPctDisplay] =
    useState('');
  const [retracePctDisplay, setRetracePctDisplay] = useState('');
  useEffect(() => {
    setGreenToRedPositionsEnabled(true);
  }, []);

  useEffect(() => {
    setInRightDirectionPctDisplay(
      greenToRedPositions.inRightDirectionPct * 100 ?? 0
    );
    setRetracePctDisplay(greenToRedPositions.retracePct * 100 ?? 0);
  }, [state]);

  return (
    <div className={style.moduleStyle}>
      <span className={style.tacticName}>
        <InfoIconComponent docs={GreenToRedPositionsDocs} /> Green to Red
        Positions
      </span>

      <div className={style.inputs}>
        <div className={style.inputAndLabel}>
          <p>Right Direction %</p>
          <NumberInputWithUnit
            direction="right"
            type="number"
            value={inRightDirectionPctDisplay}
            setValue={setInRightDirectionPctDisplay}
            onBlur={(value) =>
              dispatchGreenToRedPositions({ inRightDirectionPct: value / 100 })
            }
          >
            %
          </NumberInputWithUnit>
        </div>

        <div className={style.inputAndLabel}>
          <p>Retrace %</p>
          <NumberInputWithUnit
            direction="right"
            type="number"
            value={retracePctDisplay}
            setValue={setRetracePctDisplay}
            onBlur={(value) =>
              dispatchGreenToRedPositions({ retracePct: value / 100 })
            }
          >
            %
          </NumberInputWithUnit>
        </div>

        {/*   <div className={style.inputAndLabel}>
          <p>PnL Tracking</p>
          <select
            value={greenToRedPositions.pnlTracking}
            onChange={({ target }) =>
              dispatchGreenToRedPositions({ pnlTracking: target.value })
            }
          >
            <option value="unrealized">Track Unrealized PnL</option>
            <option value="overall">Track Overall PnL</option>
          </select>
        </div> */}
      </div>
    </div>
  );
}
GreenToRedPositionsModule.propTypes = {
  state: PropTypes.array.isRequired,
};
export default GreenToRedPositionsModule;
